import React from 'react'
import { useTranslation } from 'react-i18next'
import { scroller } from 'react-scroll'
import { Link as RouterLink, useHistory, useLocation } from 'react-router-dom'
import { Box, Link, Typography } from '@material-ui/core'
import { navLinks } from 'src/types/global'
import { useStyles } from './Sidebar.styles'

const Sidebar = ({ isOpen, toggleSidebar }: any) => {
  const { t } = useTranslation()
  const location = useLocation()
  const history = useHistory()
  const classes = useStyles(isOpen)

  const handleContactClick = () => {
    if (location.pathname !== '/') {
      history.push({
        pathname: '/',
        state: { scrollTo: 'contact' }
      })
    } else {
      scroller.scrollTo('contact', {
        smooth: true,
        duration: 1000
      })
    }
    toggleSidebar()
  }

  return (
    <>
      <Box className={classes.sidebarContainer}>
        <Box className={classes.sidebarWrapper}>
          <Box className={classes.sidebarMenu}>
            {navLinks.map(({ to, label }) => (
              <Link
                key={to}
                component={RouterLink}
                to={to}
                underline="none"
                onClick={toggleSidebar}
                className={classes.hoverLink}
              >
                <Typography
                  variant="body1"
                  color="textPrimary"
                  className={classes.typography}
                >
                  {t(label)}
                </Typography>
              </Link>
            ))}
            <Link
              onClick={handleContactClick}
              className={classes.hoverLink}
              underline="none"
            >
              <Typography
                variant="body1"
                color="textPrimary"
                className={classes.typography}
              >
                {t('navbar.contact')}
              </Typography>
            </Link>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default Sidebar
